































































































































































































































































//@ts-nocheck
//@ts-ignore
import { Component, Vue } from 'vue-property-decorator';


//@ts-ignore
import departamentos from '@/mixins/axios/general_departamentos'

//@ts-ignore
import pmd_arboles_problema from '@/mixins/axios/pmd_arboles_problema'

//@ts-ignore
import pmd_arboles_objetivos from '@/mixins/axios/pmd_arboles_objetivos'


//@ts-ignore
import dependencias from '@/mixins/axios/general_secretarias'

//@ts-ignore
import departamentos from '@/mixins/axios/general_departamentos'


//@ts-ignore
import TablePPoa from '@/components/tables/tablev1'
//@ts-ignore
import { email, required } from 'vuelidate/lib/validators';
//@ts-ignore
import Notiflix from "notiflix";
//import {Vuetable,VuetablePagination} from 'vuetable-2'
 import OrganizationChart from 'vue-organization-chart'
  import 'vue-organization-chart/dist/orgchart.css'


@Component({
  components: {
   OrganizationChart
  },

  data() {

    return {

        causas_selec:[],
          fullcard:false,
        type:'Creacion',
        problema_select:{
            problema:''
        },
        dependencias:[],
        departamentos:[],
problema:'',
        iddepartamento:0,
        idsecretaria:0,
        identificador:null,

        saveeditefecto:{
    data:{text:'',objetivo:''},
type:null,
i1:0
},
saveeditcausa:{
    data:{text:''},
type:null,
i1:0,
i2:0,
i3:0
},
objetivo_sel:null,
        causas_n:[],
        efectos_n1:[
           
            
        ],
         efectos_n2:[
            
           
        ],
         efectos_n3:[
          
           
        ],
        
    }
   
  },
  mixins:[pmd_arboles_problema,departamentos,dependencias,pmd_arboles_objetivos],
  methods:{
      selectCausa(index){

if(index in this.causas_selec){
   this.causas_selec=  this.causas_selec.slice(0, index).concat(this.causas_selec.slice(index+1, this.causas_selec.length))
}else{
    this.causas_selec.push(index);

}

      },
onChange(event){
//console.log(event.target.value)
this.getDataDepartamentos(event.target.value);
},



async getObjetivo() {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
id:this.$store.state.objetivo_sel.id,

};

let data= await this.GET_PMDID_ARBOLES_OBJETIVOS(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                       //this.problema_select=response; 
                       this.efectos_n1=JSON.parse(response.fines)[0];
                       this.efectos_n2=JSON.parse(response.fines)[1];
                       this.efectos_n3=JSON.parse(response.fines)[2];
                        this.causas_n=JSON.parse(response.componentes);
                         this.problema=response.objetivo;
                         console.log(response)
                          console.log(this.efectos_n3)
                          this.objetivo_sel=response;
//console.log(response)
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},

async getPeoblema() {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
id:this.$store.state.objetivo_sel.id,

};

let data= await this.GET_PMDID_ARBOLES(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                       this.problema_select=response; 
                       this.efectos_n1=JSON.parse(response.efectos)[0];
                       this.efectos_n2=JSON.parse(response.efectos)[1];
                       this.efectos_n3=JSON.parse(response.efectos)[2];
                        this.causas_n=JSON.parse(response.causas);
                         //this.problema=response.problema;
//console.log(response)
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},
async getDataDepartamentos(id) {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
iddependencia:id,
idmunicipio:this.$store.state.user.usuario.id_municipio

};

let data= await this.GET_GENERAL_DEPARTAMENTOS(data).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.departamentos=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},
      async getDataSecretarias() {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
idmunicipio:this.$store.state.user.usuario.id_municipio
};

let data= await this.GET_SECRETARIAS(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.dependencias=response;
this.getDataDepartamentos(response[0].id);
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},

     async create(){
//alert(this.type)
         if('edit'==this.$route.query.type){
             let dat={
                 id:this.$store.state.arbol_problema.idobjetivos,
idarbol_problema:this.$store.state.arbol_problema.id,
           
             objetivo:this.problema, 
              fin:[this.efectos_n1,this.efectos_n2,this.efectos_n3], 
               componentes:this.causas_n
         };
           
          
          let data= await this.EDITAR_PMD_ARBOLES_OBJETIVOS(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;

this.$router.push('/mun/general/pmd/arbol')

                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar crear Mir, refresque la pagina");

                    }
 this.$root.$emit('loading', false);
                    //loading.close();
                });
return;
         }else{
             
         

         let dat={
idarbol_problema:this.$store.state.arbol_problema.id,
           
             objetivo:this.problema, 
              fin:[this.efectos_n1,this.efectos_n2,this.efectos_n3], 
               componentes:this.causas_n
         };
           
          
          let data= await this.CREAR_PMD_ARBOLES_OBJETIVOS(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;

this.$router.push('/mun/general/pmd/arbol')

                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar crear Mir, refresque la pagina");

                    }
 this.$root.$emit('loading', false);
                    //loading.close();
                });
                }

      },
//pmd_arboles_problema
      
      add_i(type,index:0,index2:0){
switch (type) {
    case 'n1':
        this.efectos_n1.push({text:'efecto'})
        break;
         case 'n2':
         this.efectos_n2.push({text:'efecto'})
        break;
         case 'n3':
         this.efectos_n3.push({text:'efecto'})
        break;
          case 'c1':
         this.causas_n.push({text:'causa',childs:[]})
        break;
         case 'child_causa':
         this.causas_n[index].childs.push({text:'causa',childs:[]})
        break;
         case 'child_child_causa':
         this.causas_n[index].childs[index2].childs.push({text:'causa'})
        break;

    default:
        break;
}
      },
      editefectosave(){

let i1=this.saveeditefecto.i1;
            switch (this.saveeditefecto.type) {
              case 'e1':
              this.efectos_n1[i1]=this.saveeditefecto.data;
            
                  
                  break;
                  case 'e2':
                   this.efectos_n2[i1]=this.saveeditefecto.data;
                  break;
                  case 'e3':
                   this.efectos_n3[i1]=this.saveeditefecto.data;
            
                  break;
          
              default:
                  break;
          }
          this.saveeditefecto.data={text:'',objetivo:''};
          $('#modalEfecto').modal('hide');
      },
      editcausasave(){

let i1=this.saveeditcausa.i1;
let i2=this.saveeditcausa.i2;
let i3=this.saveeditcausa.i3;
            switch (this.saveeditcausa.type) {
              case 'c1':
              this.causas_n[i1]=this.saveeditcausa.data;
            
                  
                  break;
                  case 'c2':
                   this.causas_n[i1].childs[i2]=this.saveeditcausa.data;
                  break;
                  case 'c3':
                   this.causas_n[i1].childs[i2].childs[i3]=this.saveeditcausa.data;
            
                  break;
          
              default:
                  break;
          }
          this.saveeditcausa.data={text:'',objetivo:''};
          $('#modalCausa').modal('hide');
      },
      editefecto(type,data:any,i1:0){
this.saveeditefecto.data=data;
           this.saveeditefecto.type=type;
           this.saveeditefecto.i1=i1;
 
          $('#modalEfecto').modal('show');
      },
      editcausa(type,data:any,i1:0,i2:0,i3:0){

           this.saveeditcausa.data=data;
           this.saveeditcausa.type=type;
           this.saveeditcausa.i1=i1;
           this.saveeditcausa.i2=i2;
           this.saveeditcausa.i3=i3;
 
          $('#modalCausa').modal('show');
      },
      delete_causa(type,i1:0,i2:0,i3:0){
          switch (type) {
              case 'c1':
              this.causas_n=  this.causas_n.slice(0, i1).concat(this.causas_n.slice(i1+1, this.causas_n.length))
            
                  
                  break;
                  case 'c2':
                   this.causas_n[i1].childs=  this.causas_n[i1].childs.slice(0, i2).concat(this.causas_n[i1].childs.slice(i2+1, this.causas_n[i1].childs.length))
            
                  break;
                  case 'c3':
                   this.causas_n[i1].childs[i2].childs=  this.causas_n[i1].childs[i2].childs.slice(0, i3).concat(this.causas_n[i1].childs[i2].childs.slice(i3+1, this.causas_n[i1].childs[i2].childs.length))
            
                  break;
          
              default:
                  break;
          }
      },
      delete_efecto(nivel,i){
          console.log(nivel)
           console.log(i)
          if(nivel=='n1'){
              console.log('n1--')
            this.efectos_n1=  this.efectos_n1.slice(0, i).concat(this.efectos_n1.slice(i+1, this.efectos_n1.length))
            console.log( this.efectos_n1)
            if(this.efectos_n1.length<=0){
                this.efectos_n2=[];
                 this.efectos_n3=[];

            }
          }
          if(nivel=='n2'){
               console.log('n2--')
            this.efectos_n2=  this.efectos_n2.slice(0, i).concat(this.efectos_n2.slice(i+1, this.efectos_n2.length))
            if(this.efectos_n2.length<=0){
               
                 this.efectos_n3=[];

            }
          }
          if(nivel=='n3'){
               console.log('n3--')
            this.efectos_n3=  this.efectos_n3.slice(0, i).concat(this.efectos_n3.slice(i+1, this.efectos_n3.length))
          }

      },
      validacion()
      {

          //
      },
      add(data){
$('#modalCausa').modal('show')
          switch (data.type) {
              case 1:
                  //alert('causa');
                  break;
                   case 2:
                //  alert('hijo efecto');
                  break;
                   case 3:
                  
//alert('hijo causa');
                  break;
                   case 4:
                  
                  break;
          
              default:
                  break;
          }






      },
      hola(data){
console.log(data);
      }
   
  },
  created(){
      
  },
  mounted(){

      if(this.$route.query.type=='edit'){
          this.type='Edicion';
//this.getPeoblema();
this.getObjetivo();
      }else{
           this.type='Creacion';
//this.getPeoblema();
this.getObjetivo();
      }
   
   
  }
})
export default class Home extends Vue {}

